import formatPrice from '../price/format-price';

type DiscountPercent<T> = (oPrice: T, nPrice: T) => number;

const discountPercent: DiscountPercent<number | string> = (oPrice, nPrice) => {
    let discountPercent;
    let oldPrice = oPrice;
    let newPrice = nPrice;

    oldPrice = formatPrice(oldPrice).replace(',', '.');
    oldPrice = parseFloat(oldPrice);

    newPrice = formatPrice(newPrice).replace(',', '.');
    newPrice = parseFloat(newPrice);

    discountPercent = 100 - (newPrice * 100) / oldPrice;
    // discountPercent = Math.floor(discountPercent);
    discountPercent = Number(discountPercent.toFixed(0));

    return discountPercent;
};

export default discountPercent;
